<template>
  <div class="modal-content" @click.stop>
    <div class="modal-header">
      <h2>Política de Privacidad</h2>
      <button @click="$emit('close')" class="close-btn" aria-label="Cerrar modal">&times;</button>
    </div>
    <div class="modal-body">
      <p><strong>Fecha de vigencia:</strong> 1 de enero de {{ currentYear }}</p>
      <p>Neliel Papelería y Novedades se compromete a proteger la privacidad de sus usuarios. La información que recopilamos se utiliza únicamente para mejorar nuestros servicios y comunicarnos con usted.</p>

      <h4>1. Información que recopilamos</h4>
      <p>Recopilamos información que usted nos proporciona directamente, como nombre, correo electrónico y número de teléfono al completar nuestro formulario de contacto.</p>

      <h4>2. Uso de la información</h4>
      <p>La información recopilada se utiliza exclusivamente para responder a sus consultas y mejorar nuestros servicios. No vendemos ni compartimos su información con terceros sin su consentimiento.</p>

      <h4>3. Contacto</h4>
      <p>Para cualquier duda sobre esta política, puede contactarnos en <strong>contacto@neliel.mx</strong>.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  emits: ['close'],
  computed: {
    currentYear() { return new Date().getFullYear(); },
  },
}
</script>

<style scoped>
.modal-content { background-color: #fff; padding: 30px; border-radius: 15px; box-shadow: 0 5px 25px rgba(0,0,0,0.2); width: 90%; max-width: 800px; max-height: 90vh; overflow-y: auto; text-align: left; position: relative; font-family: 'Inter', 'Poppins', sans-serif; color: #333; }
.modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #eee; padding-bottom: 15px; margin-bottom: 20px; }
.modal-header h2 { margin: 0; font-family: 'Lora', serif; color: var(--brand-dark-teal, #003b4c); font-size: 1.8rem; }
.close-btn { background: none; border: none; font-size: 2.5rem; font-weight: 300; line-height: 1; cursor: pointer; color: #aaa; transition: color 0.3s ease; }
.close-btn:hover { color: #333; }
.modal-body h4 { font-family: 'Lora', serif; color: var(--brand-dark-teal, #003b4c); margin-top: 25px; margin-bottom: 10px; font-size: 1.3rem; }
.modal-body p { line-height: 1.8; margin-bottom: 15px; }
</style>
